import { Stack, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { ToastContentProps } from 'react-toastify'

type CustomNotificationProps = ToastContentProps<{
  title: string
  formattedDate: string
}>

export function CustomNotification({ data }: CustomNotificationProps) {
  if (!data) {
    return null
  }

  return (
    <Stack>
      <Typography variant="subtitle2" color="text.primary">
        {data.title}
      </Typography>
      <Typography variant="body2" color="text.primary">
        <FormattedMessage
          id={'setup.territory.restoreOrders.customNotification.content'}
          values={{
            b: chunks => (
              <Typography component="span" variant="body2" fontWeight="bold" display="inline">
                {chunks}
              </Typography>
            ),
            date: data.formattedDate,
          }}
        />
      </Typography>
    </Stack>
  )
}
